import { Injectable } from "@angular/core";
import { IID_FEASABILITY_CONNECTION_REQUEST } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDConnectionRequestQuery } from "./iidConnectionRequest.query";
import { IIDConnectionRequestStore } from "./iidConnectionRequest.store";
import { Observable, of } from "rxjs";
import {FeasibilityOperatorDto, FeasibilityConnectionTypeDto} from "@common/dto/feasibilityToolLookups.dto";
import { HttpClient } from "@angular/common/http";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { InterfaceDataService } from "../interfaceDataRegistry";

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_FEASABILITY_CONNECTION_REQUEST)
export class IIDConnectionRequestService extends CrudService<IID_FEASABILITY_CONNECTION_REQUEST, IIDConnectionRequestStore, IIDConnectionRequestQuery> {
  constructor(
    protected store: IIDConnectionRequestStore,
    public query: IIDConnectionRequestQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    protected _http: HttpClient,
  ) {
    super(
      Topics.IID_FEASABILITY_CONNECTION_REQUEST,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  fetchNetworkOperators$(): Observable<FeasibilityOperatorDto[]> {
    return of([
    {
        "text": "Unifiber",
        "value": 8502
    },
    {
        "text": "Unifiber Puglia",
        "value": 8507
    },
    {
        "text": "1_Unidata",
        "value": 8306
    }
]);
 /*    return this._http
        .get<FeasibilityOperatorDto[]>(`${environment.apiUrl}/api/iid_feasability_request_identifier/feasibility/tool/operators`);
   */}

  fetchConnectionType$(): Observable<FeasibilityConnectionTypeDto[]> {
    return of([
    {
        "pk_connection_type": '1',
        "value": "P2P",
    },
    {
        "pk_connection_type": '2',
        "value": "GPON",
    },
    {
        "pk_connection_type": '3',
        "value": "DARK-FIBER",
    },
    {
        "pk_connection_type": '4',
        "value": "LAN2LAN",
    },
    {
        "pk_connection_type": '5',
        "value": "GPON BUSINESS",
    },
]);
    /* return this._http
        .get<FeasibilityConnectionTypeDto[]>(`${environment.apiUrl}/api/iid_feasability_request_identifier/feasibility/tool/connectionTypes`);
   */}
}
